// extracted by mini-css-extract-plugin
module.exports = {"newCaption":"NewCaption_newCaption__1f0fj"};